export default "./images/WN75.jpg";